var render = function render(){var _vm=this,_c=_vm._self._c;return _c('r-modal',{staticClass:"recipe-select-store",on:{"cancel":_vm.close}},[_c('r-select',{attrs:{"options":_vm.stores},on:{"update":_vm.emitSelectedStore}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }